(function () {
  'use strict';

  function hydrate(video) {
    if (!video || video.getAttribute('data-origin-ready') === 'true') return;

    var sources = video.querySelectorAll('[data-origin-src]');
    Array.prototype.forEach.call(sources, function (source) {
      source.src = source.getAttribute('data-origin-src');
      source.removeAttribute('data-origin-src');
    });

    video.setAttribute('data-origin-ready', 'true');
    video.preload = 'metadata';
    video.load();
  }

  function unload(video) {
    if (!video || video.getAttribute('data-origin-ready') !== 'true') return;

    try {
      if (!video.paused) video.pause();
    } catch (error) {}

    var currentSrc = '';
    var sources = video.querySelectorAll('source');
    Array.prototype.forEach.call(sources, function (source) {
      if (source.getAttribute('src')) {
        currentSrc = source.getAttribute('src');
        source.setAttribute('data-origin-src', currentSrc);
        source.removeAttribute('src');
      }
    });

    if (!currentSrc && video.getAttribute('src')) {
      currentSrc = video.getAttribute('src');
      video.setAttribute('data-origin-src', currentSrc);
      video.removeAttribute('src');
    }

    video.preload = 'none';
    video.removeAttribute('data-origin-ready');

    // Defer load() so Safari does not sync-decode/clear on the scroll frame.
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () {
        try { video.load(); } catch (error) {}
      }, { timeout: 2500 });
    } else {
      window.setTimeout(function () {
        try { video.load(); } catch (error) {}
      }, 250);
    }
  }

  function pauseVideos(section, exception) {
    var videos = section.querySelectorAll('[data-origin-video]');
    Array.prototype.forEach.call(videos, function (video) {
      if (video !== exception && !video.paused) video.pause();
    });
  }

  function unloadFarVideos(section, keep) {
    var videos = section.querySelectorAll('[data-origin-video]');
    Array.prototype.forEach.call(videos, function (video) {
      if (video === keep) return;
      unload(video);
    });
  }

  function primeMediaFromChapterOne(section) {
    if (section.getAttribute('data-origin-media-primed') === 'true') return;
    section.setAttribute('data-origin-user-activated', 'true');
    section.setAttribute('data-origin-media-primed', 'true');

    // Unlock only the first Origins video under the user gesture.
    // Loading all Origins videos at once freezes iPhone Safari.
    var firstVideo = section.querySelector('[data-origin-video]');
    if (!firstVideo) return;

    hydrate(firstVideo);
    var originalVolume = firstVideo.volume;
    firstVideo.volume = 0;
    firstVideo.currentTime = 0;

    var request = firstVideo.play();
    if (!request || typeof request.then !== 'function') {
      firstVideo.pause();
      firstVideo.currentTime = 0;
      firstVideo.volume = originalVolume;
      return;
    }

    request.then(function () {
      firstVideo.pause();
      firstVideo.currentTime = 0;
      firstVideo.volume = originalVolume;
      firstVideo.setAttribute('data-origin-media-unlocked', 'true');
    }).catch(function () {
      firstVideo.volume = originalVolume;
      section.removeAttribute('data-origin-media-primed');
    });
  }

  function initialize(section) {
    if (section.getAttribute('data-origin-initialized') === 'true') return;
    section.setAttribute('data-origin-initialized', 'true');

    var steps = Array.prototype.slice.call(section.querySelectorAll('[data-origin-beat]'));
    var currentIndex = -1;
    var stillTimer = 0;
    var enterTimer = 0;
    var started = false;
    var activeVideo = null;

    function stopWithMediaError(video, error) {
      section.setAttribute('data-origin-state', 'media-error');
      section.setAttribute('data-origin-media-error', error.name + ': ' + error.message);
      window.console.error('Origins media playback failed:', video.getAttribute('aria-label'), error);
    }

    function attemptPlayback(video, restart, onSuccess) {
      hydrate(video);
      pauseVideos(section, video);
      unloadFarVideos(section, video);
      activeVideo = video;

      if (restart) {
        try {
          video.currentTime = 0;
        } catch (error) {}
      }

      var request;
      try {
        request = video.play();
      } catch (error) {
        stopWithMediaError(video, error);
        return;
      }

      if (!request || typeof request.then !== 'function') {
        if (onSuccess) onSuccess();
        return;
      }

      request.then(function () {
        if (onSuccess) onSuccess();
      }).catch(function (error) {
        stopWithMediaError(video, error);
      });
    }

    function clearStep() {
      if (stillTimer) {
        window.clearTimeout(stillTimer);
        stillTimer = 0;
      }

      if (currentIndex >= 0 && steps[currentIndex]) {
        steps[currentIndex].classList.remove('is-active');
      }
    }

    function completeSequence() {
      section.setAttribute('data-origin-state', 'complete');
      if (activeVideo) {
        try {
          if (!activeVideo.paused) activeVideo.pause();
        } catch (error) {}
      }
    }

    function playPayoff(step) {
      var viralQc = step.querySelector('[data-origin-viral-qc]');
      if (!viralQc) {
        completeSequence();
        return;
      }

      viralQc.addEventListener('ended', completeSequence, { once: true });
      attemptPlayback(viralQc, true, function () {
        section.setAttribute('data-origin-state', 'viral-qc');
      });
    }

    function showStep(index) {
      clearStep();

      if (index >= steps.length) {
        completeSequence();
        return;
      }

      currentIndex = index;
      var step = steps[index];
      var video = step.querySelector('[data-origin-video]');
      var duration = Number(step.getAttribute('data-origin-duration'));

      step.classList.add('is-active');
      section.setAttribute('data-origin-step', String(index + 1));
      section.setAttribute('data-origin-state', 'playing');
      section.removeAttribute('data-origin-media-error');

      if (step.hasAttribute('data-origin-payoff')) {
        playPayoff(step);
        return;
      }

      if (video) {
        video.addEventListener('ended', function () {
          showStep(index + 1);
        }, { once: true });
        attemptPlayback(video, true);
        return;
      }

      if (activeVideo) {
        unloadFarVideos(section, null);
        activeVideo = null;
      }

      stillTimer = window.setTimeout(function () {
        showStep(index + 1);
      }, Number.isFinite(duration) && duration > 0 ? duration : 4000);
    }

    function startSequence() {
      if (started) return;
      started = true;
      section.setAttribute('data-origin-started', 'true');
      showStep(0);
    }

    function resumeCurrent() {
      if (!started || currentIndex < 0) return;
      var step = steps[currentIndex];
      if (!step) return;
      var video = step.querySelector('[data-origin-video]');
      if (!video) return;
      if (video.getAttribute('data-origin-ready') === 'true' && !video.paused) return;
      attemptPlayback(video, false);
    }

    if (!steps.length) return;

    if (!('IntersectionObserver' in window)) {
      startSequence();
      return;
    }

    var startObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
          if (!started) {
            if (enterTimer) return;
            enterTimer = window.setTimeout(function () {
              enterTimer = 0;
              startSequence();
            }, 200);
            return;
          }

          if (entry.intersectionRatio >= 0.45) {
            resumeCurrent();
          }
          return;
        }

        if (enterTimer) {
          window.clearTimeout(enterTimer);
          enterTimer = 0;
        }

        // Far from viewport: pause immediately; release buffers off the scroll frame.
        if (started && entry.intersectionRatio === 0) {
          pauseVideos(section, null);
          unloadFarVideos(section, null);
        }
      });
    }, {
      rootMargin: '0px 0px',
      threshold: [0, 0.25, 0.45]
    });

    startObserver.observe(section);
  }

  function initializeAll() {
    var sections = document.querySelectorAll('[data-origin-sequence]');
    Array.prototype.forEach.call(sections, initialize);

    document.addEventListener('click', function (event) {
      var trigger = event.target && event.target.closest ? event.target.closest('[data-awakening-pad-entry]') : null;
      if (!trigger) return;

      // Prime the first Origins video while the approved click still owns user activation.
      Array.prototype.forEach.call(sections, primeMediaFromChapterOne);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
})();
